import script from "./order-book-table.vue?vue&type=script&setup=true&lang=ts"
export * from "./order-book-table.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__